import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query';
import { queryClient } from '.';
import { type EditUser, type User } from '../../shared/types';
import { deleteAdminUser, getAdminUsers, postAdminUser, putAdminUser } from '../utilities/api';

export const queryKeys = {
    getAdminUsers: () => ['admin', 'users', 'get'],
};

export const useAdminUsers = (): UseQueryResult<User[], Error> => {
    return useQuery({ queryKey: queryKeys.getAdminUsers(), queryFn: getAdminUsers, staleTime: Infinity });
};

export const useUpdateAdminUser = () => {
    return useMutation({
        mutationFn: ({ id, data }: { id: string; data: EditUser }) => putAdminUser(id, data),
        onSuccess: (newUser: User) => {
            queryClient.setQueryData(queryKeys.getAdminUsers(), (users: User[]) => {
                return users.map((user) => (user._id === newUser._id ? newUser : user));
            });
        },
    });
};

export const useCreateAdminUser = () => {
    return useMutation({
        mutationFn: (data: EditUser) => postAdminUser(data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.getAdminUsers() }),
    });
};

export const useDeleteAdminUser = () => {
    return useMutation({
        mutationFn: (id: string) => deleteAdminUser(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.getAdminUsers() });
        },
    });
};
